// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/components/button/style.scss
// module id = 426
// module chunks = 0 1